export default __webpack_public_path__ + "static/media/about-sec.fd20c60f.png";